export enum AuthFlowType {
    IdentityVerification = "IDV",
    IdentityVerificationMobile = "IDVM",
    IdentityVerificationComplete = "IDVComplete",
    KnowYourClient = "KYC",
    Pause = "PAUSE",
    Stop = "STOP",
    VerifyPasscode = "MFA",
    VerifyPhoneOtp = "VerifyPhoneOtp",
    VerifyEmailCode = "VerifyEmailCode",
    ChannelSelection = "ChannelSelection",
    KnowledgeBasedAuthentication = "KBA",
    DisableVpn = "DisableVpn",
}
